import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'filterBy',
  standalone: false,
})
export class MxFilterByPipe implements PipeTransform {
  transform<T extends object>(
    items: T[] | null | undefined,
    keys: string[] | null | undefined,
    value: unknown
  ): T[] {
    if (!items?.length || !keys?.length) {
      return items ?? [];
    }

    return items.filter((item) =>
      keys.some((key) => (item as Record<string, unknown>)?.[key] === value)
    );
  }
}
